export const netLibConf = {
  apiClientId: process.env.API_CLIENT_ID,
  apiClientSecret: process.env.API_CLIENT_SECRET,
  apiDefaultVersion: process.env.API_VERSION,
  apiDomain: process.env.API_DOMAIN,
  apiHost: process.env.API_HOST,
  apiKey: process.env.API_KEY,
  apiRvxgDomain: process.env.API_RVXG_DOMAIN,
  apiTimeout: process.env.API_TIMEOUT,
  changePasswordUrl: process.env.CHANGE_PWD_URL,
  customFixedQueryParams: { managerOwned: true },
  enviroment: process.env.ENVIRONMENT,
  googleMapsClientId: process.env.GMAPS_CLIENT_ID,
  googleMapsKey: process.env.GMAPS_KEY,
  loginReturnUrl: process.env.URL,
  shouldUseMock: process.env.USE_MOCK === 'true',
  singleSignOnBaseUrl: process.env.SSO_URL,
  storageAccessTokenId: process.env.LOCAL_STORAGE_ID,
  templateBaseUrl: process.env.TEMPLATE_BASE_URL,
};

export const pageConf = {
  searchbar: {
    name: 'searchbar',
    templateKey: 'searchbar',
    templateDataKey: 'filters',
  },
  widget: {
    name: 'widget',
    templateKey: 'quickStats',
    templateDataKey: 'widgets',
  },
  table: {
    name: 'table',
    templateKey: 'table',
    templateDataKey: 'columns',
  },
  threedots: {
    name: 'threedots',
    templateKey: 'threedots',
    templateDataKey: 'actions',
  },
};

export const allOption = (t) => ({
  label: t('filters.all'),
  value: 'all',
  id: 'all',
});

export const COMPONENTS = 'components';
export const QUICKSTATS_SIDEMENU_OPTION = 'quickStats';
export const SEARCHBAR_SIDEMENU_OPTION = 'searchbar';
export const STATUS_ERROR = 'error';
export const STATUS_IDLE = 'idle';
export const STATUS_SUCCESS = 'success';
export const SUSPEND = 'SUSPEND';
export const TABLE_SIDEMENU_OPTION = 'table';
export const KPIS_SIDEMENU_OPTION = 'kpis';

export const SAVE = 'save';
export const EDIT = 'edit';

export const SEARCHBAR_FILTERS_LIMIT = 4;
export const QUICKSTATS_WIDGETS_LIMIT = 3;
export const KPI_WIDGETS_LIMIT = 99;
export const TABLE_COLUMNS_LIMIT = 12;

export const RIGHT_ID = 'right';
export const LEFT_ID = 'left';

export const MEMBER_USER_TYPE = 'member';
export const ADMIN_USER_TYPE = 'cer_admin';
export const CONFIG_ADMIN_USER_TYPE = 'config_admin';
export const MEMBER_VIEW_USER_TYPE = 'member_view';
export const ADMIN_VIEW_USER_TYPE = 'cer_admin_view';
export const CONFIG_ADMIN_VIEW_USER_TYPE = 'config_admin_view';
export const SECONDARY = 'secondary';
